export default function () {
    return {
        restrict: 'E',
        replace: true,
        template: require('../partials-html/vehicle-details-modal.html')
    };
}



// WEBPACK FOOTER //
// ./Client/app/sink/main/partials-js/vehicleDetailsModal.js